import { render, staticRenderFns } from "./search-bar-categories.vue?vue&type=template&id=9d45e058"
import script from "./search-bar-categories.vue?vue&type=script&lang=js"
export * from "./search-bar-categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports